module.exports = __webpack_public_path__ + "static/img/a-logo-rond.45196dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a-logo-rond.png
// module id = 7gem
// module chunks = 1